import { render, staticRenderFns } from "./RecRL_Rows.vue?vue&type=template&id=2be9c9d2"
import script from "./RecRL_Rows.vue?vue&type=script&lang=js"
export * from "./RecRL_Rows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports